import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=f20a0dca&scoped=true&"
import script from "./section1.vue?vue&type=script&lang=js&"
export * from "./section1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20a0dca",
  null
  
)

export default component.exports